import React, { useState } from "react";

import { translate } from "../../utils/translation";
import DragDropUploadFile from "./generic-upload-button/DragDropUploadFile";
import isEmpty from "../../validation/is-empty";
import PropTypes from "prop-types";

UploadModal.propTypes = {
  data: PropTypes.object,
  uploadFunction: PropTypes.func,
};

export default function UploadModal(props) {
  const { data } = props;
  const { uploadFunction } = props;

  const [error, setError] = useState({});
  const [highlight, setHighlight] = useState(false);

  const [file, setFile] = useState([]);

  // To reset File Input
  const [inputKey, setInputKey] = useState(0);

  data.file = file;
  data.setError = setError;
  data.error = error;

  return (
    <div className="pdu-container">
      <div className="general-row-container">
        <FileTray file={file} />
      </div>
      <div className="general-row-container">
        <DragDropUploadFile
          setFile={setFile}
          allowMultiple={false}
          highlight={highlight}
          setHighlight={setHighlight}
          error={error}
          setError={setError}
          inputKey={inputKey}
          setInputKey={setInputKey}
        />
      </div>
      <div className="general-row-container">
        <UploadError error={error} setError={setError} />
      </div>
      <div className="general-button-container">
        <Upload data={data} uploadFunction={uploadFunction} />
      </div>
    </div>
  );
}

/// props validation | SQ(javascript:S6774)
FileTray.propTypes = {
  file: PropTypes.array,
};
function FileTray(props) {
  const { file } = props;
  let fileName = translate("No File Added");

  if (!isEmpty(file)) {
    fileName = file[0].name;
  }

  return (
    <div className="pdu-file-display">
      <b>{translate("File")}:</b> {fileName}
    </div>
  );
}

Upload.propTypes = {
  data: PropTypes.object,
  uploadFunction: PropTypes.func,
};

function Upload(props) {
  const { data } = props;
  const { uploadFunction } = props;

  return (
    <button
      className="general-upload-button"
      onClick={async () => {
        uploadFunction(data);
      }}
    >
      {translate("Upload")}
    </button>
  );
}

UploadError.propTypes = {
  error: PropTypes.object,
};
function UploadError(props) {
  const { error } = props;
  return (
    <div className="pdu-error-container">
      <div className={error.type}>
        <b>{error.text}</b>
      </div>
    </div>
  );
}
